import {KTCard} from '../../../_metronic/helpers'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import {PageOverlayer} from '../../../components/PageOverlayer'
import {Header} from './components/header/Header'
import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider, useQueryResponseLoading} from './core/QueryResponseProvider'
import {Table} from './table/Table'

const franchiseBreadcrumbs: Array<PageLink> = [
  {
    title: 'Gestão de Franquias',
    path: '/apps/franchise/franchise',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const FranchisePage = () => {
  const {itemIdForUpdate} = useListView()

  return (
    <>
      <PageTitle breadcrumbs={franchiseBreadcrumbs}>Lista de Franquias</PageTitle>
      <QueryRequestProvider>
        <QueryResponseProvider>
          <ListViewProvider>
            <>
              <KTCard>
                <Header />
                <Table />
              </KTCard>
              {itemIdForUpdate !== undefined}
            </>
          </ListViewProvider>
        </QueryResponseProvider>
      </QueryRequestProvider>
    </>
  )
}

export default FranchisePage
